import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

/** Super admins: limit the network cost view on this server to super admins only. */
export default function NetworkAccessToggle({ initial }) {
    const [on, setOn] = useState(Boolean(initial.super_admins_only));
    const [busy, setBusy] = useState(false);

    const change = async (v) => {
        setBusy(true);
        try {
            const r = await api.put("/admin/billing/network/settings", { super_admins_only: v });
            setOn(r.data.super_admins_only);
            toast.success(v ? "Network costs: super admins only" : "Network costs: every admin with billing access");
        } catch (e) {
            toast.error(formatApiErrorDetail(e));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="flex items-center gap-3 border border-white/10 rounded-md px-4 py-3 bg-[#0a0a0a]" data-testid="network-access-setting">
            <ShieldCheck className="w-4 h-4 text-white/50" />
            <div className="text-xs flex-1">
                <div className="text-white/80">Only super admins can see network costs on this server</div>
                <div className="text-white/40 text-[11px]">Off: every admin with billing access sees all servers.</div>
            </div>
            <Switch checked={on} disabled={busy} onCheckedChange={change} data-testid="network-access-toggle" />
        </div>
    );
}
